import React, { FC } from 'react';
import { Button, Tooltip } from '@scale/scaleui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ITranslateTaskResponse } from '@scale/shared/types/lookup';

interface ChatBulkAuditTranslateButtonProps {
  showTranslatedResponses: boolean;
  isLoadingTranslatingResponses: boolean;
  responses: any;
  onToggle: () => void;
  translatedTask: ITranslateTaskResponse | undefined;
}

const ChatBulkAuditTranslateButton: FC<ChatBulkAuditTranslateButtonProps> = ({
  showTranslatedResponses,
  isLoadingTranslatingResponses,
  responses,
  onToggle,
  translatedTask,
}) => {
  return (
    <>
      <Tooltip
        icon="info-circle"
        asChild={false}
        side="top"
        target={
          <Button
            disabled={
              (showTranslatedResponses && (isLoadingTranslatingResponses || !translatedTask)) ||
              !responses
            }
            onClick={onToggle}
            className="w-fit mt-1 ml-1"
          >
            <FontAwesomeIcon
              icon={[
                'fas',
                showTranslatedResponses && (isLoadingTranslatingResponses || !translatedTask)
                  ? 'spinner'
                  : showTranslatedResponses
                  ? 'globe'
                  : 'flag-usa',
              ]}
              spin={showTranslatedResponses && isLoadingTranslatingResponses}
              className="mr-1"
            />
            {showTranslatedResponses ? 'Undo Translation' : 'Translate Responses to English'}
          </Button>
        }
        text={
          showTranslatedResponses
            ? 'Undo Translation'
            : 'Translation is always on the original responses and does not include edits made within Chat Bulk Audit. Toggling on edit mode will automatically undo translation.'
        }
      />
    </>
  );
};

export default ChatBulkAuditTranslateButton;
